<template>
  <div class="">
    <!-- Loading state -->
    <base-loader v-if="loading && groups.length === 0" fetching />

    <!-- Loaded state -->
    <template v-else>
      <!-- No results -->
      <div v-if="!groups.length" class="bg-white text-sm text-center">
        <p class="p-2 m-12 font-semibold">
          {{ $t(`mygwf.components.User.ReportMeters.no_results`) }}
        </p>
      </div>

      <!-- Listing -->
      <div
        v-else
        class="relative bg-white shadow border"
        v-infinite-scroll="loadMore"
        :infinite-scroll-disabled="loading"
      >
        <div
          class="flex justify-between items-center sticky top-0 h-14 p-4 shadow-sm border-secondary border-b"
        >
          <div class="flex items-center">
            <input type="checkbox" id="export" v-model="selectAll" class="mr-2" />
            <label class="text-sm" for="export">{{
              $t(`mygwf.components.Label.select_all`)
            }}</label>
          </div>
          <base-button
            action="export"
            :disabled="selectedGroups.length === 0"
            :loading="pendingExport"
            size="sm"
            @click="onExport"
            ><base-icon icon="download" />
          </base-button>
        </div>
        <ul
          class="overflow-y-auto"
          style="min-height: calc(100vh - 25rem); max-height: calc(100vh - 25rem)"
        >
          <li
            v-for="group in groups"
            :key="group.uuid"
            :class="[
              'border-b border-gray-200 hover:bg-secondary-light  flex items-stretch',
              $route.params?.uuid === group.uuid ? 'bg-secondary hover:bg-secondary' : '',
            ]"
          >
            <div class="p-4">
              <input type="checkbox" :value="group.uuid" v-model="selectedGroups" />
            </div>

            <div
              class="p-4 grid grid-flow-col grid-cols-2 w-full justify-between cursor-pointer"
              @click="onDeviceGroupSelected(group.uuid)"
            >
              <div class="">
                <p class="truncate">{{ group.name }}</p>
                <p class="truncate text-sm text-secondary-dark">{{ group.description }}</p>
              </div>
              <div class="text-right">
                <span class="text-sm">{{ companies[group.company] }}</span>
                <div class="flex items-center justify-end text-primary">
                  <base-icon size="sm" icon="meter-icon" class="mr-1" />
                  <span class="">{{ group.installations.length }}</span>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </template>
  </div>
</template>

<script>
import infiniteScroll from 'vue-infinite-scroll'
import {BaseIcon, BaseLoader, BaseButton} from '@/components/base'
import fileExport from '@/state/helpers/fileExport'

export default {
  components: {
    BaseIcon,
    BaseLoader,
    BaseButton,
  },

  directives: {infiniteScroll},

  props: {
    groups: {
      type: Array,
      required: true,
    },
    paginationData: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      selectedGroups: [],
      pendingExport: false,
    }
  },

  computed: {
    companies() {
      const result = {}
      this.$store.getters['companies/list'].forEach(e => (result[e.id] = e.name))
      return result
    },

    selectAll: {
      get: function () {
        return this.groups ? this.selectedGroups.length === this.groups.length : false
      },
      set: function (value) {
        var selected = []

        if (value) {
          this.groups.forEach(group => {
            selected.push(group.uuid)
          })
        }
        this.selectedGroups = selected
      },
    },
  },

  methods: {
    loadMore() {
      if (!this.loading && this.paginationData.next) {
        this.$emit('loadMore')
      }
    },

    onDeviceGroupSelected(uuid) {
      this.$router.push({name: 'DeviceGroupCrud', params: {uuid}})
      this.$store.dispatch('deviceGroups/setEditedGroup', {uuid: uuid, mode: 'edit'})
    },

    async onExport() {
      if (this.pendingExport) {
        return
      }
      try {
        this.pendingExport = true
        const data = await this.$store.dispatch('deviceGroups/exportGroupsDevices', {
          groupUuids: this.selectedGroups,
          format: 'xlsx',
        })
        const fileName =
          data.filename ||
          `multiple-groups-export-${new Date().toISOString().substring(0, 10)}.xlsx`
        fileExport(data.blob, fileName)
        await this.$store.dispatch('app/notification', {
          type: 'success',
          group: 'app',
          text: 'export',
        })
      } catch (e) {
        await this.$store.dispatch('app/notification', {
          type: 'error',
          group: 'app',
          text: 'export_failed',
        })
      } finally {
        this.pendingExport = false
        this.selectedGroups = []
      }
    },
    // selectClick(group) {
    //   this.selectedGroups.includes(group.uuid)
    //     ? this.selectedGroups.filter(item => item !== group.uuid)
    //     : this.selectedGroups.push(group.uuid)
    // },
  },
}
</script>
